import { Component } from '@angular/core';

@Component({
  selector: 'app-znoexiste',
  templateUrl: './znoexiste.component.html',
})
export class ZnoexisteComponent  { 
  title:string = "No existe URL";  
}